import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQ = ({ t }) => {
  return (
    <section
      id="faq"
      className="relative py-14 md:py-20 bg-bendito-bg"
      data-testid="faq-section"
    >
      <div className="max-w-4xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="mb-12 reveal">
          <div className="eyebrow mb-3">{t.faq.eyebrow}</div>
          <h2 className="font-heading text-bendito-ink text-4xl md:text-5xl lg:text-6xl uppercase tracking-tight">
            <span className="ink-underline">{t.faq.title}</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-2" data-testid="faq-accordion">
          {t.faq.items.map((item, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="bg-bendito-surface border border-bendito-border rounded-none px-2"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="px-4 py-5 hover:no-underline text-left">
                <span className="font-heading text-bendito-ink text-xl md:text-2xl tracking-wider uppercase pr-4">
                  {item.q}
                </span>
              </AccordionTrigger>
              <AccordionContent className="px-4 pb-5 text-bendito-muted leading-relaxed text-base">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
